module.exports = __webpack_public_path__ + "static/media/pasta.7f3d685d.svg";